var map = {
	"./bg.png": "0939",
	"./chose.png": "6c58",
	"./fail.png": "02f8",
	"./step1.png": "e904",
	"./step2.png": "a334",
	"./step3-.png": "68dd",
	"./step3.png": "3140",
	"./step4.png": "d9a8",
	"./step5.png": "f062",
	"./step6.png": "067a",
	"./step7.png": "4f95",
	"./step8.png": "62de",
	"./submit.png": "3fbe",
	"./success.png": "cd65",
	"./upload.png": "45b8",
	"./video_submit.png": "71dc",
	"./video_vote.png": "1aaa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aa92";